import { render, staticRenderFns } from "./IconUserPlus.vue?vue&type=template&id=3ec817fe"
import script from "./IconUserPlus.vue?vue&type=script&lang=js"
export * from "./IconUserPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports